"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var LegalDocumentPage_1 = require("@/components/legal/LegalDocumentPage");
var privacy_es_1 = require("@/content/legal/privacy.es");
var LanguageContext_1 = require("@/contexts/LanguageContext");
var usePageMeta_1 = require("@/hooks/usePageMeta");
var Privacidad = function () {
    var t = (0, LanguageContext_1.useLanguage)().t;
    (0, usePageMeta_1.usePageMeta)({
        title: t("meta.privacyTitle"),
        description: t("meta.privacyDescription"),
        path: "/privacidad",
    });
    return (0, jsx_runtime_1.jsx)(LegalDocumentPage_1.default, { document: privacy_es_1.privacyEs });
};
exports.default = Privacidad;
